<template>
  <div class="mx-6">
    <div
      class="mb-0" 
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'">
      <v-icon class="mr-1">mdi-wrench</v-icon>
     Administration
    </div>

    <v-card
      color="transparent"
      v-resize="onResize"
      class="overflow-y-auto pt-1 pb-2"
      flat
      :height="cardHeight">
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="3" md="4" sm="6">
            <egg-farm-dialog :disabled="!isAdmin" />
          </v-col>
          <v-col cols="12" lg="3" md="4" sm="6">
            <egg-operator-dialog :disabled="!isAdmin && !isMgr" />
          </v-col>
          <v-col cols="12" lg="3" md="4" sm="6">
            <egg-account-dialog :disabled="!isAdmin" />
          </v-col>
           <v-col cols="12" lg="3" md="4" sm="6">
            <egg-line-dialog :disabled="!isAdmin" />
          </v-col>
          <v-col cols="12" lg="3" md="4" sm="6">
            <egg-upload-dialog :disabled="!isMgr && !isAdmin" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AccountDialog from '../components/AccountDialog'
import FarmDialog from '../components/FarmDialog'
import LineDialog from '../components/LineDialog'
import OperatorDialog from '../components/OperatorDialog'
import UploadDialog from '../components/UploadDialog'
import { mapState } from 'vuex'

export default {
  components: {
    'egg-account-dialog': AccountDialog,
    'egg-farm-dialog': FarmDialog,
    'egg-line-dialog' : LineDialog,
    'egg-operator-dialog': OperatorDialog,
    'egg-upload-dialog': UploadDialog
  },
  data() {
    return {
      cardHeight: 0
    };
  },
  computed: {
    ...mapState(['settings', 'isOnline']),
    isAdmin() {
      if (this.userContext == null) return false;
      return this.userContext.contextName == 'ADMIN';
    },
    isMgr() {
      if (this.userContext == null) return false;
      return this.userContext.contextName == 'MANAGER';
    },
    userContext() {
      return this.settings.userContext;
    }
  },
  beforeDestroy() {
  },
  methods: {
    onResize() {
      this.cardHeight = window.innerHeight - 155;
    }
  }
}
</script>